import { DataGrid, formatDate } from '@ijoin/components';
import { GetAdminPlanFundsRes, useGetAdminPlanFunds } from '@ijoin/hooks';
import { Link, Stack } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

import { camelCase } from 'lodash';
import { FC } from 'react';

const columns: GridColDef<GetAdminPlanFundsRes>[] = [
  {
    field: 'description',
    flex: 2,
    headerName: 'Description'
  },
  {
    field: 'cusip',
    flex: 0.75,
    headerName: 'CUSIP'
  },
  {
    field: 'tickerSymbol',
    flex: 0.75,
    headerName: 'Ticker'
  },
  {
    field: 'analysisUrl',
    headerName: 'Analysis',
    renderCell: params =>
      params.value ? (
        <Link
          data-testid={camelCase(`analysisUrl ${params.row.description}`)}
          href={params.value}
          rel='noopener'
          target='_blank'>
          Analysis
        </Link>
      ) : null,
    sortable: false,
    width: 100
  },
  {
    field: 'externalId',
    flex: 1,
    headerName: 'External ID'
  },
  {
    field: 'externalModelId',
    flex: 1,
    headerName: 'External Model ID'
  },
  {
    field: 'fundType',
    flex: 0.75,
    headerName: 'Fund Type'
  },
  {
    field: 'pathTypes',
    flex: 1.25,
    headerName: 'Path Type',
    valueGetter: (_value, row) => row.pathTypes.join(', ')
  },
  {
    field: 'updatedAt',
    flex: 1,
    headerName: 'Updated At',
    valueFormatter: value =>
      value ? formatDate(value, { format: 'MM/DD/YYYY h:mm:ss A' }) : ''
  }
];

export const PlanFundsTab: FC<{ planId: string }> = props => {
  const funds = useGetAdminPlanFunds(props.planId);

  return (
    <Stack spacing={1} sx={{ flex: 1, minHeight: 0 }}>
      <DataGrid
        autoHeight={false}
        columns={columns}
        disableColumnMenu
        disableRowSelectionOnClick
        getRowId={row => row.fundId}
        loading={funds.isFetching}
        pinnedColumns={{ left: ['description'] }}
        rows={funds.data ?? []}
        showColumnMenu
        slotProps={{
          root: {
            'data-component': 'dataGrid',
            'data-testid': 'planFunds'
          }
        }}
        sx={{ flex: 1, minHeight: 0 }}
      />
    </Stack>
  );
};

PlanFundsTab.displayName = 'PlanFundsTab';
